import {Component} from 'react';
import {useLocation} from 'react-router-dom';

class Boundary extends Component {
  state={failed:false, attempt:0};
  static getDerivedStateFromError() { return {failed:true}; }
  render() {
    if(this.state.failed) return <div role="alert" className="ls-card p-6 space-y-4" data-testid="call-recovery">
      <h1 className="text-lg font-semibold">Telefonmodus erneut öffnen</h1>
      <p>Die Ansicht konnte nicht dargestellt werden. Bereits erfasste Ergebnisse bleiben zur Bestätigung vorgemerkt.</p>
      <button className="gold-btn rounded-xl px-4 py-3" onClick={()=>this.setState(s=>({failed:false,attempt:s.attempt+1}))}>Ansicht wiederherstellen</button>
      <a className="block underline" href="/m/home">Zur Übersicht</a>
    </div>;
    return <div key={this.state.attempt}>{this.props.children}</div>;
  }
}
export default function CallRecovery({children}) {
  const location=useLocation();
  return <Boundary key={location.pathname+location.search}>{children}</Boundary>;
}
